import {useContext, useState, useReducer} from 'react';
import {useSearchParams} from 'react-router-dom';

import {MailOutline, LockOutlined} from '@mui/icons-material';

import {Form} from '../../../components';
import {LoginRequest, sendPostRequest, URLs} from '../../../api';
import AppContext from '../../../context/AppContext';
import {updateProperty} from '../../../utils';

export const LoginForm = () => {
  const {dispatchError, loginCallback} = useContext(AppContext);

  const [searchParams] = useSearchParams();
  const to = searchParams.get('to');

  const [errors, setErrors] = useState<Record<string, any>>({});
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const handleSubmit = (data: any) => {
    const request = data as LoginRequest;

    sendPostRequest(URLs.login, request)
      .then((response) => {
        const newError = response.data.user ? false : 'Wrong email or password`';
        setErrors(updateProperty(errors, 'email', newError));
        if (errors['email'] === false) {
          loginCallback({
            ...response.data.user,
            id: parseInt(response.data.user.id, 10),
            enrolledGroupContestIds: response.data.enrolledGroupContestIds,
            token: response.data.token,
            redirectTo: to ? to : null,
          });
        } else {
          forceUpdate();
        }
      })
      .catch((err) => {
        if (err) {
          if (err.response && err.response.data && err.response.data.error) {
            dispatchError({errorMessage: err.response.data.error, redirectURL: '/'});
          } else {
            dispatchError({errorMessage: 'There was an error. Please try again later', redirectURL: '/'});
          }
        }
      });
  };

  return (
    <>
      <Form
        button={{
          className: 'mt-10 mb-10',
          label: 'Log in',
          onClick: handleSubmit,
        }}
        formClass="mt-25"
        fullWidth={true}
        inputClass="mb-10"
        inputs={[
          [
            {
              id: 'email',
              error: errors['email'],
              placeholder: 'Email',
              rules: {},
              startAdornment: <MailOutline />,
              type: 'input',
            },
          ],
          [
            {
              id: 'password',
              error: errors['password'],
              placeholder: 'Password',
              rules: {},
              startAdornment: <LockOutlined />,
              type: 'password-input',
            },
          ],
        ]}
      />
      {/* <Typography variant="h6_grey">
        <a className="purple-link" href="/reset-password">
          Forgot the password?
        </a>
      </Typography> */}
    </>
  );
};
